import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

const WEIGHT_RULES_PATH = '/api/WeightRules';

export const routes = {
  getWeightRulesPath: (params) => `/api/WeightRules${getQueryParams(params)}`,
  getWeightRulePath: (id) => `/api/WeightRules/${id}`,
  deleteWeightRulePath: (id) => `/api/WeightRules/${id}`,
  restoreWeightRulePath: (id) => `/api/WeightRules/${id}/restore`,
  auditWeightRulePath: (id) => `/api/WeightRules/${id}/Audits`,
  auditWeightRuleUsersPath: (id) => `/api/WeightRules/${id}/Audits/Users`,
  auditWeightRulePropertiesPath: (id) => `/api/WeightRules/${id}/Audits/Properties`,
  getWeightRuleDuplicateCheckPath: () => '/api/WeightRules/isDuplicate',
  getWeighRuleExportPath: (params) => `/api/WeightRules/export${getQueryParams(params)}`,
};

export const getWeightRules = (params) => makeRequest(authFetch.get(routes.getWeightRulesPath(params)));
export const upsertWeightRule = (weightRule) => makeRequest(authFetch.put('/api/WeightRules', weightRule));

export const getWeightRule = (id) => makeRequest(authFetch.get(routes.getWeightRulePath(id)));
export const deleteWeightRule = (id) => makeRequest(authFetch.delete(routes.deleteWeightRulePath(id)));
export const restoreWeightRule = (id) => makeRequest(authFetch.patch(routes.restoreWeightRulePath(id)));

export const getWeightRuleDuplicateCheck = (weightRule) => makeRequest(authFetch.patch(routes.getWeightRuleDuplicateCheckPath(), weightRule));

export const getWeightRuleExport = (params) => makeRequest(authFetch.get(routes.getWeighRuleExportPath(params)));

// audit
export const getWeightRuleAudits = (id, params) => makeRequest(authFetch.get(routes.auditWeightRulePath(id, params)));
export const getWeightRuleAuditUsers = (id) => makeRequest(authFetch.get(routes.auditWeightRuleUsersPath(id)));
export const getWeightRuleAuditProperties = (id) => makeRequest(authFetch.get(routes.auditWeightRulePropertiesPath(id)));

export const getWeightRulesLookup = () => makeRequest(authFetch.get(`${WEIGHT_RULES_PATH}/Lookup`));
export const useGetWeightRulesLookup = () => useQuery(['weightRulesLookup'], getWeightRulesLookup, { ...CacheConfig.forever });
